export const uk = {
    'edit-smart-centers': 'Изменить смарт-центры',
    'no-formats-message':
        'Для данного объявления редактирование смарт-центров недоступно, попробуйте использовать другое изображение',
    'no-image-message': 'Редактирование смарт-центров недоступно для объявлений без изображения'
};
